// Single source of truth for every public number: prices, trial policy, Fortune pricing, coverage.
export const TRIAL_DAYS = 14;
export const FULL_MONTHLY = 399;
export const ADDITIONAL_STATE_MONTHLY = 199;
export const SCOUT_MONTHLY = 149;
export const PLACEMENT_MONTHLY = 1500;
export const PLACEMENT_PER_SIGNED = 250;
export const ANSWERING_MONTHLY = 199;
export const ANSWERING_INCLUDED_MINUTES = 500;
export const ANSWERING_OVERAGE_PER_MIN = 0.25;
export const ANNUAL_MONTHS_FREE = 2;

export const annual = (monthly) => monthly * (12 - ANNUAL_MONTHS_FREE);
export const usd = (n) => `$${Number(n).toLocaleString()}`;

export const TRIAL_POLICY = `${TRIAL_DAYS}-day trial, card required, auto-renews at ${usd(FULL_MONTHLY)}/mo per state unless cancelled`;
export const TRIAL_SHORT = `${TRIAL_DAYS}-day trial · card required · auto-renews at ${usd(FULL_MONTHLY)}/mo per state unless cancelled`;

export const FORTUNE_CABINET = 3500;
export const FORTUNE_DELIVERY = 500;
export const FORTUNE_PRICE = `${usd(FORTUNE_CABINET)} per cabinet · free delivery & install on 2+ (${usd(FORTUNE_DELIVERY)} for one)`;

export const COVERAGE = "50 states + DC";
// Live counters report 51 (50 states + DC). Never show "51 states".
export const statesLabel = (n) => (n >= 51 ? "50 + DC" : n ? String(n) : null);

export const TIERS = [
  {
    id: "scout",
    name: "Scout",
    monthly: SCOUT_MONTHLY,
    unit: "1 state",
    blurb: "The database for one state with one-click call and email. For a single operator working a list alone.",
    bullets: ["1 state · every eligible venue with verified owner contacts", "One-click call & email from your own phone and inbox", "Notes, statuses, callback reminders", "No team seats · no done-for-you campaigns"],
    cta: "Talk to us about Scout",
    interest: "pricing_scout",
    accent: "cyan",
  },
  {
    id: "full",
    name: "Full Operator",
    monthly: FULL_MONTHLY,
    unit: "per state",
    extra: `Additional states ${usd(ADDITIONAL_STATE_MONTHLY)}/mo each`,
    blurb: "Everything an operator needs to place machines in a state: the verified database, approve-before-send AI calls and email, team seats and the CRM.",
    bullets: ["Verified owner contacts for every eligible venue in your state", "Lucky AI calls + email — you approve every batch before it goes out", "Team seats for your reps · follow-ups · touch history", `Additional states ${usd(ADDITIONAL_STATE_MONTHLY)}/mo each`, TRIAL_POLICY],
    cta: `Start ${TRIAL_DAYS}-day trial`,
    interest: "pricing_full",
    accent: "yellow",
    highlighted: true,
    checkout: true,
  },
  {
    id: "placement",
    name: "Placement Engine",
    monthly: PLACEMENT_MONTHLY,
    unit: "done-for-you",
    noAnnual: true,
    extra: `+ ${usd(PLACEMENT_PER_SIGNED)} per placement, billed up front`,
    blurb: "We run the whole engine for you: lists, Lucky calls, email, callbacks and appointments — you sign the placements.",
    bullets: ["Dedicated campaign across your states and venue types", "Lucky AI calling + email run and monitored by Arcade Ops", "Callbacks and appointments booked onto your calendar", `${usd(PLACEMENT_PER_SIGNED)} per placement, charged up front when the placement is created — work starts once it's paid`],
    cta: "Talk to us",
    interest: "pricing_placement",
    accent: "magenta",
  },
];

export const ADDONS = [
  {
    id: "answering",
    name: "AI answering service",
    monthly: ANSWERING_MONTHLY,
    unit: "per number",
    noAnnual: true,
    blurb: `Lucky answers your inbound line 24/7 — questions about the machines and pricing, qualifies the caller, books appointments, takes messages, texts and emails you a summary, transfers urgent calls. ${ANSWERING_INCLUDED_MINUTES} minutes included, then $${ANSWERING_OVERAGE_PER_MIN.toFixed(2)}/min.`,
    cta: "Add to my plan",
    interest: "pricing_answering",
  },
];
